<template>
  <label class="flex items-center gap-1.5" data-testid="affiliate-competence">
    <span class="text-[11px] font-semibold uppercase tracking-wider text-neutral50"
      >Competência</span
    >
    <select
      class="max-w-[300px] rounded-full border border-[#a3a3a3] bg-white px-3 py-1.5 text-[13px] text-[#525252]"
      aria-label="Competência"
      data-testid="affiliate-competence-select"
      :value="modelValue"
      @change="onChange"
    >
      <option v-for="option in options" :key="option.value" :value="option.value">
        {{ option.label }}
      </option>
    </select>
  </label>
</template>

<script setup lang="ts">
import type { CompetenceOption } from '../competence'

const props = defineProps<{ modelValue: string; options: CompetenceOption[] }>()
const emit = defineEmits<{ 'update:modelValue': [competence: string] }>()

function onChange(event: Event): void {
  const value = (event.target as HTMLSelectElement).value
  if (value && value !== props.modelValue) emit('update:modelValue', value)
}
</script>
